import React from 'react';
import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Button } from '@material-ui/core';
import PropTypes from 'prop-types';

interface IProps {
  cancel: () => void;
  confirm: () => void;
  isOpen: boolean;
  message: string;
  title: string;
}

const Alert = ({ cancel, confirm, isOpen, message, title }: IProps) => {
  return (
    <Dialog open={isOpen} onClose={cancel} aria-labelledby="form-dialog-title">
      <DialogTitle id="form-dialog-title">{title}</DialogTitle>
      <DialogContent>
        <DialogContentText>{message}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={cancel} color="primary">
          Cancel
        </Button>
        <Button onClick={confirm} color="primary">
          Confirm
        </Button>
      </DialogActions>
    </Dialog>
  );
};

Alert.propTypes = {
  cancel: PropTypes.func.isRequired,
  confirm: PropTypes.func.isRequired,
  isOpen: PropTypes.bool.isRequired,
  message: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
};

export default Alert;
